import { render } from "./HourglassIcon.vue?vue&type=template&id=7f0d9479&scoped=true"
import script from "./HourglassIcon.vue?vue&type=script&lang=js"
export * from "./HourglassIcon.vue?vue&type=script&lang=js"

import "./HourglassIcon.vue?vue&type=style&index=0&id=7f0d9479&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0d9479"]])

export default __exports__